import React from 'react';
import type { SpinProps as BaseSpinProps } from 'antd';

import { Spinner } from './styled.ts';

// TODO: styling spin from figma
export const BaseSpin: React.FC<BaseSpinProps> = ({ ...props }) => <Spinner {...props} />;
